$("#com-btn").click(function(){
  alert($("header").scrollTop());
});
$(document).ready(function(){
    $("#widthBtn").click(function(){
        $(".main-box").addClass("show");
        $(".search_size_option").show();
        $(".search_vehicle_option").hide();
        $(".overlay").addClass("show");
        $("body").addClass("no-scroll");
      $("html").addClass("no-scroll");
    });
    $("#vehicleBtn").click(function(){
        make_obj();
        $(".main-box").addClass("show");
        $(".overlay").addClass("show");
        $("body").addClass("no-scroll");

         $(".search_size_option").hide();
        $(".search_vehicle_option").show();
        $("body").addClass("no-scroll");
      $("html").addClass("no-scroll");
        
    });
    $(".cancel-btn").click(function(){
        $(".main-box").removeClass("show");
        $(".overlay").removeClass("show");
        $("body").removeClass("scroll");
       $("body").removeClass("no-scroll");
      $("html").removeClass("no-scroll");

       
    });
});

